import React from "react";
import { Box } from "@mui/material";
import SidebarContent from "./SidebarContent";
import { PROFILE_SIDEBAR_HEIGHT } from "../helpers/layoutConstants";

function Sidebar() {
  return (
    <>
      {/* Sidebar Container */}
      <Box
        sx={{
          height: PROFILE_SIDEBAR_HEIGHT, // ends level with the edit-profile panel
          overflow: "auto", // Enable scrolling for overflow content
          padding: "16px 10px",
          borderRadius: "20px",
          backgroundColor: "#fff",
          boxShadow: "0px 20px 20px 0px #2A487610",
          display: { xs: "none", sm: "block", md: "block" }, // Show only on medium+ screens
        }}
      >
        <SidebarContent />
      </Box>
    </>
  );
}

export default Sidebar;
